module.exports = __webpack_public_path__ + "static/media/timelapse_1.03248ed4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_1.jpg
// module id = 961
// module chunks = 0